const paths = {
  listPeople: '/people/list',
  editPeople: '/people/edit'
};

export default paths;
